'use client';
export {
  createSliderScope,
  //
  Slider,
  SliderTrack,
  SliderRange,
  SliderThumb,
  SliderThumbProvider as unstable_SliderThumbProvider,
  SliderThumbTrigger as unstable_SliderThumbTrigger,
  SliderBubbleInput as unstable_SliderBubbleInput,
  //
  Root,
  Track,
  Range,
  Thumb,
  ThumbProvider as unstable_ThumbProvider,
  ThumbTrigger as unstable_ThumbTrigger,
  BubbleInput as unstable_BubbleInput,
} from './slider';
export type {
  SliderProps,
  SliderTrackProps,
  SliderRangeProps,
  SliderThumbProps,
  SliderThumbProviderProps as unstable_SliderThumbProviderProps,
  SliderThumbTriggerProps as unstable_SliderThumbTriggerProps,
  SliderBubbleInputProps as unstable_SliderBubbleInputProps,
} from './slider';
